import { useEffect } from 'react'

export const useKeyboardShortcuts = (isActive: boolean, onEscape: () => void, onEnter?: () => void) => {
    useEffect(() => {
        if (!isActive) return

        const handleKey = (event: KeyboardEvent) => {
            if (event.key === 'Escape') {
                onEscape()
            }
            if (event.key === 'Enter' && onEnter) {
                onEnter()
            }
        }

        document.addEventListener('keydown', handleKey)
        return () => document.removeEventListener('keydown', handleKey)
    }, [isActive, onEscape, onEnter])
}
